import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Icon = styled.img`
  width: 7.8rem;
  height: 7.8rem;

  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    width: 6rem;
    height: 6rem;
  }
`;

export const Title = styled(Typography)`
  text-align: center;
  font-size: 2.6rem;
  padding: 3rem 5.9rem;
`;

export const ButtonsRow = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
`;

export const Button = styled(MainButton)`
  padding: 0.75rem 2rem;
  p {
    font-size: 1.8rem;
  }
`;

// Control de ordenación de las entidades internas del informe combinado:
// selección de fecha (registro / sistema) + dirección. Mismo patrón visual que
// SortableHeader de las tablas (flecha ArrowBottom que rota en asc y se atenúa
// cuando el campo no está activo).
export const SortControl = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  padding-bottom: 2rem;
`;

export const SortOptionsRow = styled.div`
  display: flex;
  gap: 2.4rem;
  justify-content: center;
  flex-wrap: wrap;
`;

export const SortOptionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

export const SortArrow = styled.span<{ $asc: boolean; $active: boolean }>`
  display: inline-flex;
  transform: rotate(${({ $asc }) => ($asc ? '180deg' : '0deg')});
  opacity: ${({ $active }) => ($active ? 1 : 0.3)};
  transition: transform 0.15s ease;
`;

export const SortHint = styled(Typography)`
  text-align: center;
  padding: 0 3rem;
`;

// Indicador de generación (spinner + texto/progreso) mientras se construye el
// histórico/informe — sustituye a los botones durante la generación.
export const GeneratingBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.6rem;
  padding: 1rem 0 0.6rem;
`;

export const GeneratingText = styled(Typography)`
  text-align: center;
`;
